import { ReactNode, RefAttributes, useRef } from "react";
import { Container, Image, ImageProps, Row } from "react-bootstrap";
import logger from "../../libs/errorLib";
import { useCalculatedDimensions } from "../../hooks/useCalculatedDimensions";

export type ResponsiveImageProps = {
    originalHeight : number,
    originalWidth : number,
    maxHeight? : number,
    url : string,
    overlay? : ReactNode,
    className? : string,
    containerClassName? : string,
    onError? : (e : unknown) => void
} & ImageProps & RefAttributes<HTMLImageElement>

export default function ResponsiveImage({originalHeight, originalWidth, url, overlay, className, containerClassName, onError, maxHeight = originalHeight, ...props} : ResponsiveImageProps){

    const componentRef = useRef<HTMLDivElement>(null);
    const {height, width} = useCalculatedDimensions({componentRef, originalHeight, originalWidth, preferredMaxHeight: maxHeight});
    const ratio = maxHeight ? maxHeight / originalHeight : 1;
    //if(height && width) logger.debug(`Rendering image ${url} with h${height} w${width}, ratio ${height/width}, original h${originalHeight} w${originalWidth} original ratio ${originalHeight / originalWidth}`);
    return(
        <Container ref={componentRef} className={`${(containerClassName ? containerClassName : "") + " text-center p-0"}`}>
            <Image src={url}
                height={height ? height + "px" : (originalHeight * ratio) + "px"}
                width={width ? width + "px" : (originalWidth * ratio) + "px"}
                style={{
                    flexShrink: 0,
                    objectFit: "contain"
                }}
                onError={(e) => {
                    if(onError) onError(e);
                    logger.debug("Error loading image");
                }}
                className={className}
                {...props}
            />
            {overlay && (
                <Row style={{width: '100%', height: height + 'px', position: 'absolute', top: '0'}} className="text-center align-items-center p-0 m-0">
                    {overlay}
                </Row>
            )}
        </Container>
    )
}